import {IntermediatePart} from "../../intermediatePart";

export default class Radius extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'radius';
    this.partName = 'Radius';
    this.translateId = "visualizer.kitchen.countertop.radius";
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Radius());
  }

  setZIndex() {

  }
}
